import React from 'react'
import { shallow } from 'enzyme'

import HelpfulHints  from '../../features/HelpfulHints/index'

describe('HelpfulHints', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      loan: {
        helpfulHints: [
          {
            rid: 1,
            description: 'Sample description',
            category: 'business_entity',
          },
        ],
      },
      isBankUser: false,
      loanId: 123,
    },
    wrapper = shallow(<HelpfulHints {...props} />)
    instance = wrapper.instance()
  })

  describe('#onHideShowAll', () => {
    it('should change state function', () => {
      const onHideShowAll = spyOn(instance, 'onHideShowAll')
      instance.onHideShowAll()
      const linkButton = wrapper.find('#linkButton').at(0);
      linkButton.simulate('click')
      expect(onHideShowAll).toHaveBeenCalled()
      expect(wrapper.state('hideAll')).toBeTruthy()
    })
  })

  describe('#getTitle', () => {
    it('should return upper case title function', () => {
      expect(instance.getTitle('random_title')).toEqual('Random Title')
    })
  })

  describe('#groupHintsByCategory', () => {
    it('should return helpfulhints into categories', () => {
      const groupHintsByCategory = spyOn(instance, 'groupHintsByCategory')
      instance.groupHintsByCategory()
      expect(groupHintsByCategory).toHaveBeenCalled()
      expect(wrapper.state('hints').length).toEqual(1)
    })
  })
  describe('#getCategories', () => {
    it('should return helpfulhints into categories', () => {
      const categories = instance.getCategories(props.loan.helpfulHints)
      expect(categories.length).toEqual(1)
      expect(categories[0].title).toEqual('Business Entity')
    })
  })
})